import { BsGithub } from 'react-icons/bs';
import Button from '../common/button';
import { Heading } from '../common/heading';
import { GitHubTsPlaygroundLink } from '../mock/static-data';
import { last } from '../playground/generic-types/explain';
import { getDisplayName } from '../playground/generic-types/when-to-use-a-generic-type';
import { Hsu } from '../playground/key-of-&-type-of/example';
import {
	adjustMenu,
	simpleMenu,
} from '../playground/key-of-&-type-of/example-pizza';
import { RecordPersons } from '../playground/record/explain-one';
import { Pages, peopleWithRoles } from '../playground/record/with-union';
import { makeNoise, UnionSum } from '../playground/union-type/explain';

interface FormProps<T> {
	values: T;
	children: (values: T) => JSX.Element;
}
const Form = <T extends {}>({ values, children }: FormProps<T>) => {
	// Generic with JSX
	return children(values);
};

const TypeScript = () => {
	console.log('GENERIC TYPE 🚀 🚀 🚀 🚀');
	const animalResult = getDisplayName({
		name: 'Patch',
	});
	console.log('animalResult => ', animalResult);

	const l = last<string>(['1', '2', '3']);
	console.log('last ==>', l);

	const humanResult = getDisplayName({
		firstName: 'Thuta',
		lastName: 'Sann',
	});
	console.log('humanResult => ', humanResult);

	// -------------

	console.log('UNION TYPE 🚀 🚀 🚀 🚀');
	console.log('Union Sum =>', UnionSum(['1000'], [2000]));

	makeNoise({
		age: 2,
		name: 'ok',
		study: () => {
			console.log('study');
		},
		type: 'student',
	});

	const moreTsPeople = {
		hsuyeywel: 'hsuyeywel',
		thuta: 'thuta',
		pyaethuta: 'pyaethuta',
		aungaung: 'aungaung',
	};

	moreTsPeople.aungaung = 'aung aung updated';
	console.log('moreTsPeople', moreTsPeople);

	// -------------
	console.log('RECORD 🚀 🚀 🚀 🚀');

	console.log('RecordPersons', RecordPersons);
	console.log('People With Roles', peopleWithRoles);
	const admins: string[] = peopleWithRoles['admin'];
	console.log('admins', admins);
	console.log('Pages', Pages);

	// -------------
	console.log('KEYOF 🚀 🚀 🚀 🚀');
	console.log(adjustMenu(simpleMenu, 'beverage', 'cola'));

	return (
		<>
			<Heading
				text="Typescript"
				description="In this section, advanced typescript concepts will be applied. Open console to see the results"
			/>

			<a
				href={`${GitHubTsPlaygroundLink}`}
				target="_blank"
				rel="noreferrer"
				className="bg-gray-700 rounded-md px-3 py-2 hover:bg-gray-600 transition-all duration-300 ease-in-out text-sm font-[600] flex items-center gap-1 w-[120px]"
			>
				Playground <BsGithub />
			</a>

			<h2 className="mt-5 text-xl font-bold underline underline-offset-2">
				Categories
			</h2>

			<div className="flex items-center gap-3 flex-wrap">
				<Button text="Generic Type" />
				<Button text="Union Type" />
				<Button text="Auto Complete" />
				<Button text="Record" />
				<Button text="Typescript" />
			</div>

			<Form
				values={{
					firstName: 'bob',
				}}
			>
				{(values) => <div className="hidden">{values.firstName}</div>}
			</Form>
		</>
	);
};

export default TypeScript;
